import actions from './actions'

const initialState = {
  fields: [],
  loading: false,
}

export default function userProfileFieldReducer(state = initialState, action) {
  switch (action.type) {
    case actions.SET_STATE:
      return { ...state, ...action.payload }
    default:
      return state
  }
}
